export enum PayoutGatewaySlugEnum {
  Bkash = "bkash",
  "DbbL Bank" = "dbbl-bank",
  "Brac Bank" = "brac-bank",
}

export enum PayoutGatewayTypeEnum {
  Automated = "automated",
}
